// Import modules
import Register from './Register';

// Export modules
export default Register;
